import { render, staticRenderFns } from "./PhysicalActivitiesEnterpriseComp.vue?vue&type=template&id=1d5b3318&scoped=true"
import script from "./PhysicalActivitiesEnterpriseComp.vue?vue&type=script&lang=js"
export * from "./PhysicalActivitiesEnterpriseComp.vue?vue&type=script&lang=js"
import style0 from "./PhysicalActivitiesEnterpriseComp.vue?vue&type=style&index=0&id=1d5b3318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b3318",
  null
  
)

/* custom blocks */
import block0 from "./PhysicalActivitiesEnterpriseComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports